import { createActions, createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  list: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },
  detail: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  save: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  delete: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  authors: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },
  authorDetail: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  authorSave: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  authorDelete: {
    fetching: false,
    fetched: false,
    error: null,
    data: null,
  },
  businesses: {
    fetching: false,
    fetched: false,
    error: null,
    data: [],
  },
};

const { Types, Creators } = createActions(
  {
    getBlogs: ['params'],
    getBlogsRequest: [],
    getBlogsSuccess: ['data'],
    getBlogsFailure: ['error'],

    getBlog: ['id'],
    getBlogBySlug: ['slug'],
    getBlogRequest: [],
    getBlogSuccess: ['data'],
    getBlogFailure: ['error'],

    createBlog: ['data'],
    createBlogRequest: [],
    createBlogSuccess: ['data'],
    createBlogFailure: ['error'],

    updateBlog: ['id', 'data'],
    updateBlogRequest: [],
    updateBlogSuccess: ['data'],
    updateBlogFailure: ['error'],

    deleteBlog: ['id'],
    deleteBlogRequest: [],
    deleteBlogSuccess: ['data'],
    deleteBlogFailure: ['error'],

    resetBlogSave: [],
    resetBlogDetail: [],

    getBlogAuthors: [],
    getBlogAuthorsRequest: [],
    getBlogAuthorsSuccess: ['data'],
    getBlogAuthorsFailure: ['error'],

    getBlogAuthor: ['id'],
    getBlogAuthorRequest: [],
    getBlogAuthorSuccess: ['data'],
    getBlogAuthorFailure: ['error'],

    createBlogAuthor: ['data'],
    createBlogAuthorRequest: [],
    createBlogAuthorSuccess: ['data'],
    createBlogAuthorFailure: ['error'],

    updateBlogAuthor: ['id', 'data'],
    updateBlogAuthorRequest: [],
    updateBlogAuthorSuccess: ['data'],
    updateBlogAuthorFailure: ['error'],

    deleteBlogAuthor: ['id'],
    deleteBlogAuthorRequest: [],
    deleteBlogAuthorSuccess: ['data'],
    deleteBlogAuthorFailure: ['error'],

    getBlogBusinesses: [],
    getBlogBusinessesRequest: [],
    getBlogBusinessesSuccess: ['data'],
    getBlogBusinessesFailure: ['error'],
  },
  { prefix: 'cb/admin/blogManager/' },
);

export { Types as types, Creators as actions };

const listRequest = state => ({
  ...state,
  list: {
    ...state.list,
    fetching: true,
    error: null,
  },
});

const listSuccess = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const listFailure = (state, action) => ({
  ...state,
  list: {
    ...state.list,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const detailRequest = state => ({
  ...state,
  detail: {
    ...state.detail,
    fetching: true,
    error: null,
  },
});

const detailSuccess = (state, action) => ({
  ...state,
  detail: {
    ...state.detail,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const detailFailure = (state, action) => ({
  ...state,
  detail: {
    ...state.detail,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const saveRequest = state => ({
  ...state,
  save: {
    ...state.save,
    fetching: true,
    fetched: false,
    error: null,
  },
});

const saveSuccess = (state, action) => ({
  ...state,
  save: {
    ...state.save,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const saveFailure = (state, action) => ({
  ...state,
  save: {
    ...state.save,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const deleteRequest = state => ({
  ...state,
  delete: {
    ...state.delete,
    fetching: true,
    fetched: false,
    error: null,
  },
});

const deleteSuccess = (state, action) => ({
  ...state,
  delete: {
    ...state.delete,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const deleteFailure = (state, action) => ({
  ...state,
  delete: {
    ...state.delete,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const authorsRequest = state => ({
  ...state,
  authors: {
    ...state.authors,
    fetching: true,
    error: null,
  },
});

const authorsSuccess = (state, action) => ({
  ...state,
  authors: {
    ...state.authors,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const authorsFailure = (state, action) => ({
  ...state,
  authors: {
    ...state.authors,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const authorDetailRequest = state => ({
  ...state,
  authorDetail: {
    ...state.authorDetail,
    fetching: true,
    error: null,
  },
});

const authorDetailSuccess = (state, action) => ({
  ...state,
  authorDetail: {
    ...state.authorDetail,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const authorDetailFailure = (state, action) => ({
  ...state,
  authorDetail: {
    ...state.authorDetail,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const authorSaveRequest = state => ({
  ...state,
  authorSave: {
    ...state.authorSave,
    fetching: true,
    error: null,
  },
});

const authorSaveSuccess = (state, action) => ({
  ...state,
  authorSave: {
    ...state.authorSave,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const authorSaveFailure = (state, action) => ({
  ...state,
  authorSave: {
    ...state.authorSave,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const authorDeleteRequest = state => ({
  ...state,
  authorDelete: {
    ...state.authorDelete,
    fetching: true,
    error: null,
  },
});

const authorDeleteSuccess = (state, action) => ({
  ...state,
  authorDelete: {
    ...state.authorDelete,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const authorDeleteFailure = (state, action) => ({
  ...state,
  authorDelete: {
    ...state.authorDelete,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const businessesRequest = state => ({
  ...state,
  businesses: {
    ...state.businesses,
    fetching: true,
    error: null,
  },
});

const businessesSuccess = (state, action) => ({
  ...state,
  businesses: {
    ...state.businesses,
    fetching: false,
    fetched: true,
    data: action.data,
    error: null,
  },
});

const businessesFailure = (state, action) => ({
  ...state,
  businesses: {
    ...state.businesses,
    fetching: false,
    fetched: true,
    error: action.error,
  },
});

const resetBlogSave = state => ({
  ...state,
  save: INITIAL_STATE.save,
});

const resetBlogDetail = state => ({
  ...state,
  detail: INITIAL_STATE.detail,
});

export const HANDLERS = {
  [Types.GET_BLOGS_REQUEST]: listRequest,
  [Types.GET_BLOGS_SUCCESS]: listSuccess,
  [Types.GET_BLOGS_FAILURE]: listFailure,

  [Types.GET_BLOG_REQUEST]: detailRequest,
  [Types.GET_BLOG_SUCCESS]: detailSuccess,
  [Types.GET_BLOG_FAILURE]: detailFailure,

  [Types.CREATE_BLOG_REQUEST]: saveRequest,
  [Types.CREATE_BLOG_SUCCESS]: saveSuccess,
  [Types.CREATE_BLOG_FAILURE]: saveFailure,

  [Types.UPDATE_BLOG_REQUEST]: saveRequest,
  [Types.UPDATE_BLOG_SUCCESS]: saveSuccess,
  [Types.UPDATE_BLOG_FAILURE]: saveFailure,

  [Types.DELETE_BLOG_REQUEST]: deleteRequest,
  [Types.DELETE_BLOG_SUCCESS]: deleteSuccess,
  [Types.DELETE_BLOG_FAILURE]: deleteFailure,

  [Types.GET_BLOG_AUTHORS_REQUEST]: authorsRequest,
  [Types.GET_BLOG_AUTHORS_SUCCESS]: authorsSuccess,
  [Types.GET_BLOG_AUTHORS_FAILURE]: authorsFailure,

  [Types.GET_BLOG_AUTHOR_REQUEST]: authorDetailRequest,
  [Types.GET_BLOG_AUTHOR_SUCCESS]: authorDetailSuccess,
  [Types.GET_BLOG_AUTHOR_FAILURE]: authorDetailFailure,

  [Types.CREATE_BLOG_AUTHOR_REQUEST]: authorSaveRequest,
  [Types.CREATE_BLOG_AUTHOR_SUCCESS]: authorSaveSuccess,
  [Types.CREATE_BLOG_AUTHOR_FAILURE]: authorSaveFailure,

  [Types.UPDATE_BLOG_AUTHOR_REQUEST]: authorSaveRequest,
  [Types.UPDATE_BLOG_AUTHOR_SUCCESS]: authorSaveSuccess,
  [Types.UPDATE_BLOG_AUTHOR_FAILURE]: authorSaveFailure,

  [Types.DELETE_BLOG_AUTHOR_REQUEST]: authorDeleteRequest,
  [Types.DELETE_BLOG_AUTHOR_SUCCESS]: authorDeleteSuccess,
  [Types.DELETE_BLOG_AUTHOR_FAILURE]: authorDeleteFailure,

  [Types.GET_BLOG_BUSINESSES_REQUEST]: businessesRequest,
  [Types.GET_BLOG_BUSINESSES_SUCCESS]: businessesSuccess,
  [Types.GET_BLOG_BUSINESSES_FAILURE]: businessesFailure,

  [Types.RESET_BLOG_SAVE]: resetBlogSave,
  [Types.RESET_BLOG_DETAIL]: resetBlogDetail,
};

export default createReducer(INITIAL_STATE, HANDLERS);